<template>
  <div>
    <dialogTemplate
      :openDialog="openFlowDetail"
      :widthDialog="'1400px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @close="$emit('closeDialog')"
    >
      <template #header>
        <div style="padding-left: 32px">
          <h5 class="dialogTitle">
            Chi tiết luồng văn bản đi
          </h5>
        </div>
      </template>
      <template #body>
        <div>
          <vue2-org-tree
            v-if="root && isRender"
            :data="root"
            :horizontal="true"
            :collapsable="true"
            :renderContent="renderContent"
            @onExpand="onExpand"
            @onNodeClick="onNodeClick"
          ></vue2-org-tree>
          <vbdi-process-moreinfo-banhanh
            v-if="
            isEnable &&
              selectedNodeType === PROCESS_TREE.NODE_TYPE.BANHANH_NODE
          "
            :isOpen="isOpen"
            :docId="docId"
            @closeDialog="isOpen = false"
            @closed="isEnable = false"
          />
        </div>
      </template>
    </dialogTemplate>
  </div>


</template>

<script>
import Vue2OrgTree from "././components/vue2-tree/components/org-tree/org-tree";
import Vue from "vue";
import VbdiProcessMoreinfoCxlcanhan from "././components/vbdi-process-moreinfo-cxlcanhan.vue";
import VbdiProcessMoreinfoBanhanh from "././components/vbdi-process-moreinfo-banhanh";
import constants from "../../constants";
import vbdiLuongxulyMixin from "../../mixins/vbdi-luongxuly-mixin";
import userDeptRoleViewService from "../../services/userDeptRoleService";

Vue.use(Vue2OrgTree);

  export default {
    name: "vbdi-luongxuly-all",
    props: ["docId", "isConfigLD", "openFlowDetail"],
    mixins: [vbdiLuongxulyMixin],
    components: {VbdiProcessMoreinfoBanhanh, VbdiProcessMoreinfoCxlcanhan,
      dialogTemplate: () => import("../common/custom-dialog.vue"),
    },

    data() {
      return {
        nodeInfo: null,
        flowInstance: null,
        isOpen: false,
        isEnable: false,
        userDeptRole: null
      };
    },

    watch: {
      isOpen(newValue) {
        newValue && (this.isEnable = newValue);
      },

      docId() {
        this.init();
      }
    },

    computed: {
      selectedNodeType() {
        return this.selectedNode ? this.selectedNode.type : null;
      },

    },

    created() {
      this.init();
    },

    methods: {

      init() {
        let loadDocPromise;
        // if (this.isConfigLD) {
        //   loadDocPromise = this.loadDocForConfigLD();
        // }
        // else {
        //   loadDocPromise = this.loadDoc();
        // }
        loadDocPromise = this.loadDocForConfigLD();
        loadDocPromise
          .then(() => this.loadUserDeptRole())
          .then(() => this.loadClonedVbIncomingDocs())
          .then(() => this.loadBanHanhDepartments())
          .then(() => this.loadDocReceivers())
          .then(() => this.loadProcessForVbIncomingDoc())
          .then(() => this.convertToTreeData())
          .then(() => this.isRender = true)
      },

      loadUserDeptRole() {
        return userDeptRoleViewService
          .findById(this.userDeptRoleId)
          .then(response => (this.userDeptRole = response.data));
      },

      convertToTreeData() {
        this.root = this.buildRootNode();
        this.buildTreeDataForAfterKyDuyet(this.root);
      },

      buildRootNode() {
        let editorDeptNode = this.buildNodeForEditorDept();
        let signerNode = this.buildNodeForSigner();
        if (editorDeptNode || signerNode) {
          return (editorDeptNode || signerNode);
        } else {
          return this.buildNodeForPublisherDept();
        }
      },

      buildTreeDataForAfterKyDuyet(treeNode) {
        console.log("status:",this.doc.status)
        switch (this.doc.status) {
          case constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH:
            treeNode.children = [this.buildTreeDataForTuChoiBHanhNodes()];
            break;
          case constants.OUTGOING_DOC_STATUS.DABANHANH:
            treeNode.children = [this.buildTreeDataForBanHanhNodes()];
            break;
          case constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH:
            treeNode.children = [this.buildTreeDataForChoBanHanhNode()];
            break;
        }
        return treeNode;
      },

      buildNodeForPublisherDept() {
        let treeNode = {};
        treeNode.id = this.doc.publisherId;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.PUBLISHER_DEPT_NODE;
        treeNode.doc = this.doc;
        return treeNode;
      },

      buildNodeForEditorDept() {
        if (!this.doc.deptEditorId) return null;
        let treeNode = {};
        treeNode.id = this.doc.deptEditorId;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.EDITOR_DEPT_NODE;
        treeNode.doc = this.doc;
        return treeNode;
      },

      buildNodeForSigner() {
        if (!this.doc.signerId) return null;
        let treeNode = {};
        treeNode.id = this.doc.signerId;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.SIGNER_NODE;
        treeNode.doc = this.doc;
        return treeNode;
      },

      renderSignerNode(h, data) {
        let doc = this.doc;
        let classes = [
          "node_handlder flex-row flex__center",
          this.user.id === doc.signerId ? "active" : ""
        ];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "profileIsRead"}, [
              h("div", {class: "avatar_fake flex-row flex__center"}, [
                h("span", this.buildShortName(doc.signerName))
              ]),
              h("i", {
                class:
                  "fas fa-check-circle font-size__medium icon-read border-radius__50"
              })
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, doc.signerName),
              doc.signerPosName ? h(
                "div",
                {class: "more-info font-size__small"},
                doc.signerPosName
              ) : null
            ])
          ])
        );
        return h("div", {class: classes.join(" ")}, components);
      },

      renderEditorDeptNode(h, data) {
        return this.renderDeptNode_(h, data, this.doc.deptEditorName);
      },

      renderPublisherDeptNode(h, data) {
        return this.renderDeptNode_(h, data, this.doc.publisherName);
      },

      renderDeptNode_(h, data, deptName) {
        let classes = [
          "node_handlder flex-row flex__center",
        ];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(deptName))
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, deptName)
            ])
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      renderContent(h, data) {

        if(data.type === constants.PROCESS_TREE.NODE_TYPE.CXL_CANHAN_PROCESS_NODE){
          console.log("data:", data)
        }

        switch (data.type) {
          case constants.PROCESS_TREE.NODE_TYPE.BANHANH_NODE:
            return this.renderBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CHOBANHANH_NODE:
            return this.renderChoBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE:
            return this.renderDonViBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANHNGOAI_NODE:
            return this.renderDonViBanHanhNgoaiNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE:
          case constants.PROCESS_TREE.NODE_TYPE.TUCHOI_NODE:
            return this.renderTuChoiNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.PUBLISHER_DEPT_NODE:
            return this.renderPublisherDeptNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.EDITOR_DEPT_NODE:
            return this.renderPublisherDeptNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.SIGNER_NODE:
            return this.renderSignerNode(h, data);


          case constants.PROCESS_TREE.NODE_TYPE.CXL_DONVI_PROCESS_NODE:
            return this.renderCxlDonViProcessNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CXL_CANHAN_PROCESS_NODE:
            return this.renderCxlCaNhanProcessNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CHUYENTIEP_NODE:
            return this.renderChuyenTiepNode(h, data);
        }
      },
      // vb den
      renderCxlCaNhanProcessNode(h, data) {
        let process = data.data.process;
        let classes = ["node_handlder flex-row flex__center"];
        this.userDeptRole.userId === process.receiverId && classes.push("active");

        let components = [];
        let typeClassTag = "";
        if (process.processType === constants.PROCESS_TYPE.CHUTRI) {
          typeClassTag = "tag-chuTri";
        } else if (process.processType === constants.PROCESS_TYPE.NHANDEBIET) {
          typeClassTag = "tag-nhanDeBiet";
        } else if (process.processType === constants.PROCESS_TYPE.PHOIHOP) {
          typeClassTag = "tag-phoiHop";
        } else if (process.processType === constants.PROCESS_TYPE.LĐ_CHI_DAO){
          typeClassTag = 'tag-lanhDaoChiDao'
        }else if (process.processType === constants.PROCESS_TYPE.XIN_Y_KIEN_LĐ){
          typeClassTag = 'tag-xinYKienLanhDao'
        }

        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "profileIsRead"}, [
              h("div", {class: "avatar_fake flex-row flex__center"}, [
                h("span", this.buildShortName(process.receiverName))
              ]),
              process.isRead
                ? h("i", {
                  class:
                    "fas fa-check-circle font-size__medium icon-read border-radius__50"
                })
                : null
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, process.receiverName),
              h(
                "div",
                {class: "more-info font-size__small"},
                process.receiverPosName
              )
            ]),
            h(
              "div",
              {class: `tag ${typeClassTag}`},
              this.getProcessTypeLabel(process.processType)
            )
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      renderCxlDonViProcessNode(h, data) {
        let process = data.data.process;
        let classes = ["node_handlder flex-row flex__center"];

        let components = [];
        let typeClassTag = "";
        if (process.processType === constants.PROCESS_TYPE.CHUTRI) {
          typeClassTag = "tag-chuTri";
        } else if (process.processType === constants.PROCESS_TYPE.NHANDEBIET) {
          typeClassTag = "tag-nhanDeBiet";
        } else if (process.processType === constants.PROCESS_TYPE.PHOIHOP) {
          typeClassTag = "tag-phoiHop";
        } else if (process.processType === constants.PROCESS_TYPE.LĐ_CHI_DAO){
          typeClassTag = 'tag-lanhDaoChiDao'
        } else if (process.processType === constants.PROCESS_TYPE.XIN_Y_KIEN_LĐ){
          typeClassTag = 'tag-xinYKienLanhDao'
        }

        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(process.deptReceiverName))
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, process.deptReceiverName)
            ]),
            h(
              "div",
              {class: `tag ${typeClassTag}`},
              this.getProcessTypeLabel(process.processType)
            )
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      renderChuyenTiepNode(h, data) {
        return h("div", {class: "node_label clickable"}, [
          h("span", "Chuyển tiếp")
        ]);
      },
      getProcessTypeLabel(processType) {
        switch (processType) {
          case constants.PROCESS_TYPE.CHUTRI:
            return "Chủ trì";
          case constants.PROCESS_TYPE.NHANDEBIET:
            return "Nhận để biết";
          case constants.PROCESS_TYPE.PHOIHOP:
            return "Phối hợp";
          case constants.PROCESS_TYPE.LĐ_CHI_DAO:
            return "Lãnh đạo chỉ đạo"
          case constants.PROCESS_TYPE.XIN_Y_KIEN_LĐ:
            return "Xin ý kiến lãnh đạo"
          default:
            return "";
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/doc-out/vbdi-luongxuly-all.vue